import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { setCookie } from "./cookies";

const users = [
  { companyId: 58459, userId: 178783, companyName: "Fictícia Redes" },
  { companyId: 12702, userId: 53863, companyName: "Teste01" },
  { companyId: 70006, userId: 255931, companyName: "qa automacao" },
  { companyId: 70006, userId: 243773, companyName: "qa automacao - admin" },
  { companyId: 64204, userId: 202520, companyName: "institutoproa" },
  { companyId: 40276, userId: 73445, companyName: "Villares Metals" },
  { companyId: 3469, userId: 6092, companyName: "Britania" },
  { companyId: 12702, userId: 196186, companyName: "Teste01 - usuário qa" },
  { companyId: 59873, userId: 186489, companyName: "A7" },
];

export function FakeLogin() {
  const [selectedUserId, setSelectedUserId] = useState();

  function handleSubmit(e) {
    e.preventDefault();
    const selectedUser = users.find((user) => user.userId === selectedUserId);

    fetch("http://localhost:3001/login", {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        companyId: selectedUser.companyId,
        userId: selectedUser.userId,
        name: selectedUser.companyName,
        clientId: "frontend",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setCookie(process.env.ACCESS_TOKEN, data.token, data.expires_in);
        window.location = "/";
      })
      .catch(() => {
        console.log("erro ao logar");
      });
  }

  if (process.env.NODE_ENV === "development") {
    return (
      <form onSubmit={(e) => handleSubmit(e)}>
        <label>
          Login
          <select
            className="select-user"
            id="users"
            onChange={(e) => setSelectedUserId(Number(e.target.value))}
          >
            <option value="">Selecione</option>
            {users.map((user) => (
              <option value={user.userId} key={user.userId}>
                {user.companyName} - Usuário: {user.userId}
              </option>
            ))}
          </select>
          <button data-testid={"btn-acessar"}>Acessar</button>
        </label>
      </form>
    );
  }
}
